module.exports = __webpack_public_path__ + "img/T6-B-xh_3.208ba491.png";